import Inwins from './container'

export default Inwins
